import {
  DataTable,
  Flex,
  Card,
  formatCurrency,
  useIsMobile,
  formatPercentage,
  ProtocolIcon,
  useTableProps,
  TableSkeleton
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import { useApi, SKY_API_ENDPOINT } from '@/api';
import { Link, InfoTooltip } from '@/components';

export default function ASCTable() {
  const isMobile = useIsMobile();
  const { sorting } = useTableProps({
    initialSorting: '-total_asc'
  });
  const [data, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: `/asc/primes/`,
    queryParams: {
      sort: sorting.currentSorting
    }
  });
  if (error) {
    throw error;
  }

  if (!data?.data?.results) {
    return <TableSkeleton rows={10} columns={6} />;
  }
  const columns: TableColumn[] = [
    {
      header: '',
      getCell: (row) => (
        <Flex gap="3xs" alignItems="center">
          <ProtocolIcon protocol={row.star} size="2" />
          {row.star.toUpperCase()}
        </Flex>
      ),
      columnSize: isMobile ? '70px' : '100px'
    },
    {
      header: 'ASC',
      getCell: (row) => formatCurrency(row.total_asc),
      sortingField: 'total_asc'
    },
    {
      header: 'Resting ASC',
      getCell: (row) => formatCurrency(row.resting_asc),
      sortingField: 'resting_asc'
    },
    {
      header: 'Latent ASC',
      getCell: (row) => formatCurrency(row.latent_asc),
      sortingField: 'latent_asc'
    },
    {
      header: (
        <Flex gap="3xs">
          ASC Ratio
          <InfoTooltip text="Each Star Agent is required to contribute to the total system’s ASC proportionally to their allocated assets. Star Agents can hire each other to do this service on their behalf." />
        </Flex>
      ),
      getCell: (row) => formatPercentage(row.asc_share),
      sortingField: 'asc_share'
    }
  ];

  return (
    <Card>
      <DataTable
        rows={data.data.results}
        columns={columns}
        sorting={sorting}
        getKey={(row) => row.star}
        rowLinkProps={{
          to: (row) => `/actively-stabilizing-collateral/${row.star}`,
          // @ts-ignore
          linkComponent: Link
        }}
      />
    </Card>
  );
}
